module.exports = __webpack_public_path__ + "media/brands/humbaur-ca0a935f.png";